import type { ColGroupDef } from 'ag-grid-community'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import { formatNumber } from '../utils'

export const mwmNbUsersDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'sum',
      field: 'mwm_nbu_free_trial_d0',
      headerName: 'FreeTrial D0',
      type: 'numericColumn',
      valueFormatter: formatNumber,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'sum',
      field: 'mwm_nbu_free_trial_d10',
      headerName: 'FreeTrial D10',
      type: 'numericColumn',
      valueFormatter: formatNumber,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'sum',
      field: 'mwm_nbu_free_trial_lifetime',
      headerName: 'FreeTrial Lifetime',
      type: 'numericColumn',
      valueFormatter: formatNumber,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'sum',
      field: 'mwm_nbu_subscriber_d0',
      headerName: 'Subscriber D0',
      type: 'numericColumn',
      valueFormatter: formatNumber,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'sum',
      field: 'mwm_nbu_subscriber_d10',
      headerName: 'Subscriber D10',
      type: 'numericColumn',
      valueFormatter: formatNumber,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'sum',
      field: 'mwm_nbu_subscriber_lifetime',
      headerName: 'Subscriber Lifetime',
      type: 'numericColumn',
      valueFormatter: formatNumber,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'sum',
      field: 'mwm_nbu_paying_user_d0',
      headerName: 'Paying D0',
      type: 'numericColumn',
      valueFormatter: formatNumber,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'sum',
      field: 'mwm_nbu_paying_user_d10',
      headerName: 'Paying D10',
      type: 'numericColumn',
      valueFormatter: formatNumber,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'sum',
      field: 'mwm_nbu_paying_user_lifetime',
      headerName: 'Paying Lifetime',
      type: 'numericColumn',
      valueFormatter: formatNumber,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'lightGreyFill',
  headerName: 'MWM Nb Users',
}
